import React from "react"
import { api, firestore } from "../../core"
import { useLiveComments } from "popopo-lib-front/firestore-access"
import { getCommentDisplayValue, getCommentKindLabel } from "popopo-lib-front/live-comment-utils"
import { User } from "firebase/auth"
import { LiveCommentId, LiveId, SpaceKey } from "popopo-msg"
import { Button } from "react-bootstrap"

export const SpaceLiveCommentList = (props: { firebase: User; spaceKey: SpaceKey; liveId: LiveId }) => {
  const comments = useLiveComments(firestore, props.spaceKey, props.liveId, 100)

  const onDelete = async (id: LiveCommentId) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.DELETE("/api/v2/spaces/{space_key}/lives/{live_id}/comments/{comment_id}", {
        params: { path: { space_key: props.spaceKey, live_id: props.liveId, comment_id: id } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <ul className="list-group w-100">
        {comments === "loading" ? (
          <li>
            <i className="fas fa-spin fa-spinner" />
          </li>
        ) : comments.length === 0 ? (
          <li>コメントは1つも存在しません。</li>
        ) : (
          comments.map((comment) => (
            <li key={comment.id} className="list-group-item">
              <>
                ID: {comment.id} (kind: {getCommentKindLabel(comment.kind)}, value: {getCommentDisplayValue(comment)})
              </>
              <Button variant="danger" onClick={() => onDelete(comment.id)}>
                Delete
              </Button>
            </li>
          ))
        )}
      </ul>
    </>
  )
}
